var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-page"},[_c('img',{staticClass:"loader",attrs:{"src":"/images/loader-big.svg","alt":""}})])
}]

export { render, staticRenderFns }